// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coin98",
    name: "Coin98 Super Wallet",
    homepage: "https://coin98.com/wallet",
    image_id: "e7c6d5d0-b986-4348-de22-fc940e1aee00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/vn/app/coin98-wallet/id1561969966",
        android: "https://play.google.com/store/apps/details?id=coin98.crypto.finance.media&hl=vi&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.coin98",
    mobile: {
        native: "coin98://",
        universal: "https://coin98.com/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map